import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class ByLine extends Component {
  shouldComponentUpdate() {
    return false;
  }

  renderAuthorLink() {
    const { bylineAttribution, post } = this.props;
    const { author } = post;

    if (bylineAttribution) {
      return (
        <span className="post__by-link-no-underline">
          By {bylineAttribution}
        </span>
      );
    }

    return (
      <Link className="post__by-link" to={`/user/${author.slug}`}>
        By {author.name}
      </Link>
    );
  }

  render() {
    const { readTime } = this.props.post;
    return (
      <div className="post__byline">
        <cite className="post__by">
          {this.renderAuthorLink()}
        </cite>
        <span className="post__readTime">
          {readTime} Read
        </span>
      </div>
    );
  }
}

ByLine.propTypes = {
  post: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    author: PropTypes.shape({}).isRequired,
    readTime: PropTypes.string.isRequired
  }).isRequired,
  bylineAttribution: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/by_line.js